export default __webpack_public_path__ + "static/media/assiny.2645e61b.png";